import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class ExpertiseUser extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/expertise-user';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetExpertiseUsers';

    static model_name = 'ExpertiseUser';

    static fields() {
		return {
			id: this.attr(null),
			display_type: this.attr(null),
			show_count: this.attr(null),
			country_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
